import * as React from 'react';
import Styled from 'styled-components';

import { BreakPointsMap } from '../../lib/StyledComponents';
import { SVGIcon } from '../Icon';
import { IButtonProps } from '../Button';

export type NotificationLevel = 'error' | 'warning' | 'info' | 'success';

const DEFAULT_STYLE: NotificationLevel = 'info';

const CustomClose = Styled.button`
  cursor: pointer;
  padding: 1.5em 1em 1em 0;
  background: ${({ theme: { card } }) => card.colorBackground };

  svg {
    height: 15px;
    width: 15px;
    fill: ${({ theme : { text } }) => text.colorText};
    color: ${({ theme : { text } }) => text.colorText};
  }

  &:hover svg {
    fill: ${({ theme: { notification } }) => notification.colorHover };
    color: ${({ theme: { notification } }) => notification.colorHover };
  }
`;

export const NotificationClose = React.forwardRef<HTMLButtonElement, IButtonProps>((props, ref) => (
    <CustomClose ref={ref} {...props}>
      <SVGIcon icon='close' aria-hidden={false} iconTitle='close' />
    </CustomClose>
  )
);

export const NotificationContainer = Styled.div`
  margin-bottom: ${({ theme: { notification } }) => notification.spacing};
  background: ${({ theme: { card } }) => card.colorBackground };
  box-shadow: 0 10px 20px 0 rgba(0, 0, 0, 0.25);
  width: 360px;
  display: flex;

  /* toast notification displays as a banner on mobile */
  @media only screen and (max-width: ${BreakPointsMap.small}em) {
    width: 100%;
  }
`;

export const NotificationBody = Styled.div<{ level: NotificationLevel }>`
  padding: 1.25em 0 1em 1.5em;
  border-left-width: ${({ theme : { notification } }) => notification.widthBorder};
  border-left-style: solid;
  border-left-color: ${({ theme: { notification }, level }) => notification[level || DEFAULT_STYLE].colorBorder};
  color: ${({ theme: { text } }) => text.colorText};
  width: 100%;
`;

export const NotificationMessage = Styled.span`
  padding: 0.5em 0 0.5em 0;
  display: block;
`;

export default NotificationContainer;
